// @flow
import React from 'react'
import I18n from 'i18n-react'

// types
import type { InsuranceCompaniesType } from '../Types/InsuranceCompanyTypes'

type QuoteCallbackProps = {
  debug?: boolean,
  insuranceCompanies: InsuranceCompaniesType,
  onShowCallback: () => void,
  insuranceCompanyKey: string,
  webType: number,
}

const QuoteCallback = (props: QuoteCallbackProps) => {
  let insuranceCompany = {}
  if (props.insuranceCompanies[props.insuranceCompanyKey]) {
    insuranceCompany = props.insuranceCompanies[props.insuranceCompanyKey]
  }

  if (!insuranceCompany.name) {
    return null
  }

  return (
    <tr className='d-block d-lg-table-row'>
      <td className='align-middle py-1 border-right-0 align-items-center d-block d-lg-table-cell pl-3 pr-xl-5 text-nowrap'>
        {!!insuranceCompany.webLogo &&
        <img
          alt={insuranceCompany.name}
          className='my-2 mr-4'
          key={`quote-insuranceCompany-logo-${insuranceCompany.name}`}
          src={insuranceCompany.webLogo}
          width={80}
        />
        }
        <strong className='align-middle ml-4'>{insuranceCompany.shortName}</strong>
      </td>
      <td
        className='align-middle py-1 d-flex justify-content-between align-items-center pr-3 pr-lg-2 d-lg-table-cell text-right
        text-xl-center text-xxl-right td-lg-wide'>
        <span className='lead h3-lg align-middle px-3 px-lg-0 d-block mb-1 mt-xxl-1 float-xxl-left text-nowrap'/>
        <div className='d-flex justify-content-center justify-content-xxl-end flex-wrap pl-xxl-3'>
          <button
            className='btn btn-dark w-lg-100 w-xxl-auto'
            onClick={props.onShowCallback}
            type='button'
          >
            {I18n.translate('general.showQuoteCallback')}
          </button>
        </div>
      </td>
    </tr>
  )
}

export default QuoteCallback
